module.exports = __webpack_public_path__ + "static/media/image (16).1e859fc3.jpg";